import {useApiAuth} from "@/composables/useApiAuth";
import { useApiConfig } from "@/composables/useApiConfig";

const { auth: authConfiguration } = useApiConfig();


export default defineNuxtRouteMiddleware((to, from) => {
    const { user } = useApiAuth();

    if(user.value !== null) {
        return navigateTo(authConfiguration.redirects.userIndexPage);
    }

    return;
});